<template>
  <div id="project-overlay">
    <h1 class="slate-bold">This project has been marked as complete</h1>
  </div>
</template>

<script>
export default { name: "ProjectLockOverlay" };
</script>

<style lang="scss" scoped>
#project-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: linear-gradient(0deg, $dark, #ffffff00);

  h1 {
    padding: 1rem;
    background: $dark;
    text-align: center;
    color: white;
  }
}
</style>
